import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./about.css";

const subTitle = "From Our Creative Blog";
const title = "Latest Articles on Art, Music & Dance";

const IMAGE_BASE_URL =
  "https://kalakakshaaha.com/uploads/blogs/";

/* ===== SLUG HELPER ===== */
const slugify = (text) =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-");

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(3);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* ================= RESPONSIVE ITEMS ================= */
  useEffect(() => {
    const updateItemsPerView = () => {
      if (window.innerWidth < 768) {
        setItemsPerView(1); // Mobile
      } else if (window.innerWidth < 1200) {
        setItemsPerView(2); // Tablet
      } else {
        setItemsPerView(3); // Desktop
      }
    };

    updateItemsPerView();
    window.addEventListener("resize", updateItemsPerView);
    return () => window.removeEventListener("resize", updateItemsPerView);
  }, []);

  /* ================= FETCH BLOGS ================= */
  useEffect(() => {
    fetch("https://kalakakshaaha.com/kks/api/v1/blogs")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setBlogs(data.blogs);
        } else {
          setError("Failed to load blogs");
        }
      })
      .catch(() => setError("Something went wrong"))
      .finally(() => setLoading(false));
  }, []);

  /* ================= ARROW HANDLERS ================= */
  const handleNext = () => {
    if (currentIndex + itemsPerView < blogs.length) {
      setCurrentIndex(currentIndex + itemsPerView);
    }
  };

  const handlePrev = () => {
    if (currentIndex - itemsPerView >= 0) {
      setCurrentIndex(currentIndex - itemsPerView);
    }
  };

  if (loading) {
    return <p className="text-center text-white py-5">Loading blogs...</p>;
  }

  if (error) {
    return <p className="text-center text-danger py-5">{error}</p>;
  }

  const visibleBlogs = blogs.slice(
    currentIndex,
    currentIndex + itemsPerView
  );

  return (
    <div
      className="blog-section section-bg position-relative"
      style={{ background: "transparent" }}
    >
      <div className="container position-relative">

        {/* HEADER */}
        <div className="section-header text-center">
          <span style={{ color: "skyblue", fontWeight: "bold" , fontSize: "21px"}}>
            {subTitle}
          </span>
          <h2 className="title" style={{ color: "white" }}>
            {title}
          </h2>
        </div>

        {/* LEFT ARROW */}
        {currentIndex > 0 && (
          <button onClick={handlePrev} className="slide-btn left">
            ❮
          </button>
        )}

        {/* RIGHT ARROW */}
        {currentIndex + itemsPerView < blogs.length && (
          <button onClick={handleNext} className="slide-btn right">
            ❯
          </button>
        )}

        {/* BLOG LIST */}
        <div className="section-wrapper">
          <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 justify-content-center g-4">
            {visibleBlogs.map((blog) => (
              <div className="col" key={blog.id}>
                <div className="post-item h-100">
                  <div className="post-inner h-100 d-flex flex-column">

                    {/* IMAGE */}
                    <div className="post-thumb">
                      <img
                        src={`${IMAGE_BASE_URL}${blog.image}`}
                        alt={blog.title}
                        onError={(e) =>
                          (e.target.src =
                            "/assets/images/course/200.jpg")
                        }
                        style={{
                          width: "100%",
                          height: "250px",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />
                    </div>

                    {/* CONTENT */}
                    <div className="post-content flex-grow-1">
                      <Link to={`/blog/${slugify(blog.title)}`}>
                        <h4>{blog.title}</h4>
                      </Link>

                      <div className="meta-post">
                        <ul className="lab-ul" style={{ color: "black" }}>
                          <li>
                            <i className="icofont-ui-user"></i>
                            {blog.author}
                          </li>
                          <li>
                            <i className="icofont-calendar"></i>
                            {new Date(blog.published_date).toDateString()}
                          </li>
                        </ul>
                      </div>

                      {/* SHORT DESCRIPTION */}
                      <div
                        className="blog-short"
                        dangerouslySetInnerHTML={{
                          __html: blog.short_description,
                        }}
                      />
                    </div>

                    {/* FOOTER */}
                    <div className="post-footer">
                      <div className="pf-left">
                        <Link
                          to={`/blog/${slugify(blog.title)}`}
                          className="lab-btn-text"
                        >
                          Read More <i className="icofont-external-link"></i>
                        </Link>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* ===== INLINE CSS ===== */}
      <style>{`
        .slide-btn {
          position: absolute;
          top: 55%;
          transform: translateY(-50%);
          background: #ffffff;
          border: none;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          font-size: 22px;
          cursor: pointer;
          z-index: 20;
          box-shadow: 0 6px 15px rgba(0,0,0,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .slide-btn.left {
          left: -25px;
        }

        .slide-btn.right {
          right: -25px;
        }

        .slide-btn:hover {
          background: #ff8c00;
          color: #fff;
        }

        .blog-short {
          max-height: 100px;
          overflow: hidden;
          line-height: 1.5;
        }

        @media (max-width: 768px) {
          .slide-btn.left {
            left: 5px;
          }
          .slide-btn.right {
            right: 5px;
          }
        }
      `}</style>
    </div>
  );
};

export default Blog;
